import { makeStyles, createStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    headerRow: {
      marginBottom: '5px'
    },
    headerText: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 16,
      color: '#2C2D3E',
    },
    formInput: {
      margin: '15px',
      width: '350px',
      borderRadius: '3px',
      appearance: 'none',
    },
    formInputNarrow: {
      margin: '15px 10px',
      width: '165px',
      borderRadius: '3px',
      appearance: 'none',
    },
  }),
);
